import { Box, Typography, useTheme } from "@mui/material";
import WhatsappQrContent from "./whatsapp-qr-content";

/**
 * Full-screen blocker shown once the grace period has expired. It unmounts on
 * its own: the passport poll inside the content flips `isBlocked` to false as
 * soon as the instance reports as linked.
 */
const WhatsappBlockedOverlay = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 1500,
        backgroundColor: theme.nawy.colors.semantic.layer.primary,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflowY: "auto",
        py: theme.nawy.spacing.lg,
      }}
    >
      <Box
        sx={{
          width: { xs: "calc(100vw - 32px)", sm: 480 },
          maxWidth: 480,
          display: "flex",
          flexDirection: "column",
          gap: theme.nawy.spacing.md,
          p: theme.nawy.spacing.lg,
        }}
      >
        <Typography
          sx={{
            ...theme.nawy.typography.english.variants.headline.xs,
            color: theme.nawy.colors.semantic.text.primary,
          }}
        >
          Whatsapp business setup
        </Typography>

        <WhatsappQrContent />
      </Box>
    </Box>
  );
};

export default WhatsappBlockedOverlay;
